import { Inbox, Info, Sliders, Users } from 'react-feather'
import { DashboardBaseProps } from '../../layouts/DashboardBase'

const adminSection: DashboardBaseProps['dashboardItems'][number]['pages'] = [
    {
        icon: Sliders,
        href: '/admin/dashboard',
        titleI18n: 'site.nav.adminDashboard',
    },
    {
        icon: Users,
        href: '/admin/customers',
        titleI18n: 'site.nav.adminCustomers',
        children: [
            {
                icon: Users,
                href: '/admin/customers',
                titleI18n: 'site.nav.adminCustomers',
            },
            {
                icon: Users,
                href: '/admin/users',
                titleI18n: 'site.nav.adminUsers',
            },
        ],
    },
    {
        icon: Info,
        href: '/admin/pr-input',
        titleI18n: 'site.nav.adminPRInput',
    },
    {
        icon: Info,
        href: '/admin/pr-company',
        titleI18n: 'site.nav.adminPMCompany',
    },
    {
        icon: Info,
        href: '/admin/delistings',
        titleI18n: 'site.nav.adminDelistings',
    },
    {
        icon: Info,
        href: '/admin/press-releases',
        titleI18n: 'site.nav.pressReleases',
    },
    {
        icon: Info,
        href: '/admin/issues',
        titleI18n: 'site.nav.adminIssues',
        children: [
            { icon: Info, href: '/admin/issues', titleI18n: 'site.nav.adminIssues' },
            {
                icon: Info,
                href: '/admin/issues/review',
                titleI18n: 'site.nav.adminIssuesReview',
            },
            { icon: Info, href: '/admin/issues/new', titleI18n: 'site.nav.adminIssuesNew' },
        ],
    },
    {
        icon: Info,
        href: '/admin/warrants',
        titleI18n: 'site.nav.adminWarrants',
        children: [
            { icon: Info, href: '/admin/warrants', titleI18n: 'site.nav.adminWarrants' },
            { icon: Info, href: '/admin/warrants/new', titleI18n: 'site.nav.adminWarrantsNew' },
        ],
    },
    {
        icon: Info,
        href: '/admin/convertibles',
        titleI18n: 'site.nav.adminConvertibles',
        children: [
            { icon: Info, href: '/admin/convertibles', titleI18n: 'site.nav.adminConvertibles' },
            {
                icon: Info,
                href: '/admin/convertibles/new',
                titleI18n: 'site.nav.adminConvertiblesNew',
            },
        ],
    },
    {
        icon: Info,
        href: '/admin/investors',
        titleI18n: 'site.nav.adminInvestors',
        children: [{ icon: Info, href: '/admin/investors', titleI18n: 'site.nav.adminInvestors' }],
    },
    {
        icon: Info,
        href: '/admin/keyword-filter',
        titleI18n: 'site.nav.adminKeywordFilter',
    },
]

const adminNavItems: DashboardBaseProps['dashboardItems'] = [
    {
        titleI18n: 'site.nav.app',
        pages: [
            {
                href: '/news',
                icon: Inbox,
                titleI18n: 'site.nav.news',
            },
        ],
    },
    {
        titleI18n: 'site.nav.admin',
        pages: adminSection,
    },
]

export { adminNavItems }
